import type {ReactElement} from 'react';
import {useState} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './free-bgr-popup.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {getAssetUrl} from '@Utils/s3.util';

export function FreeBgrPopup({isVideo = false}: {isVideo?: boolean}): ReactElement<any> {
  const [isHidden, setIsHidden] = useState<boolean>(false);

  function closePopup(): void {
    setIsHidden(true);
  }

  if (isHidden) {
    return <></>;
  }

  const graphicName = isVideo ? 'free_bgr_popup_graphic_video.png' : 'free_bgr_popup_graphic_image.png';

  return (
    <div className={`flex-column-align-center radius-8 spacing-p-4 _full-width ${styles.container}`}>
      <div className="flex-row-justify-between flex-align-items-center _full-width">
        <Text val={window.i18next.t('pmwjs_enjoy_a_free_premium_perk')} size={TextSize.SMALL} bold />
        <Icon icon="icon-close" size={IconSize.SIZE_ICON_16} onClick={closePopup} isUsedAsButton />
      </div>
      <img
        className={`radius-8 spacing-m-t-4 spacing-m-b-4 _full-width ${styles.graphic}`}
        src={getAssetUrl(graphicName)}
        alt={window.i18next.t('pmwjs_enjoy_a_free_premium_perk')}
      />
      <Text val={window.i18next.t('pmwjs_busy_bg_one_clivk_gone_try_ai_bg_remover_free')} size={TextSize.XSMALL} />
    </div>
  );
}
